import { PublicBackground } from '@app/core';
import { SuccessScreen } from '../ParticipationSummary/components/SuccessScreen';
import { useTranslation } from 'react-i18next';

export const NotInterested = () => {
  const { t } = useTranslation();

  return (
    <PublicBackground>
      <SuccessScreen
        title={t('application.notInterested.title')}
        description={t('application.notInterested.description')}
      />
    </PublicBackground>
  );
};
